module.exports = __webpack_public_path__ + "assets/img/face_contrast_scene1.1b73ee70.png";